export default "//yastatic.net/s3/distribution/pythia/frontend/_/b0609dbd973da299eb430a24c3cbb237.png";